// extracted by mini-css-extract-plugin
export default {"container":"VfcmhsEGZKd2gqkgSxy4R"};